import React from 'react'

class SearchQTL extends React.Component {

}

export default SearchQTL